import { render, staticRenderFns } from "./AdicionarApresentacao.vue?vue&type=template&id=17209b5c&scoped=true&"
import script from "./AdicionarApresentacao.vue?vue&type=script&lang=js&"
export * from "./AdicionarApresentacao.vue?vue&type=script&lang=js&"
import style0 from "./AdicionarApresentacao.vue?vue&type=style&index=0&id=17209b5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17209b5c",
  null
  
)

export default component.exports